import { useState, useEffect } from "react";
import { createUseStyles } from "react-jss";

import { actionTypeService } from "services";
import { ActionTypeCommon, ActionTypeDto, ActionTypeRequestDto } from "dtos/shard/action-type.dto";
import { UserDto } from "dtos/user.dto";

import widgets from "styles/widgets";
import { useResources } from "hooks/resources.hook";
import { useEditorActions } from "hooks/editor-actions.hook";
import { useEditorPreview } from "hooks/editor-preview.hook";
import EditorControls from "../editor-controls";

const styles = createUseStyles({
    container: {
        width: "100%",
    },
});

export default function ActionTypeEditor(props: {
    user?: UserDto, // Optional dto of the user.
    actionType?: Partial<ActionTypeDto>,
    preview?: Partial<ActionTypeDto>,
    onPreviewUpdate?: (previewDto: Partial<ActionTypeDto>) => void,
    onClose?: () => void,
    onSave?:(actionType: ActionTypeDto) => void,
}): JSX.Element
{
    // Dtos:
    const freshCommon: ActionTypeCommon = {
        name: props.actionType?.name ?? "",
    };
    const freshRequestDto: ActionTypeRequestDto = {
        id: props.actionType?.id,
        ...freshCommon,
    };
    const freshPreviewDto: Partial<ActionTypeDto> = props.preview ? structuredClone(props.preview) : props.actionType ? structuredClone(props.actionType) : {
        id: undefined,
        ...freshCommon,
    };

    // Hooks:
    const resources = useResources(props.user);
    const [previewDto, requestDto, previewUpdate, setRequestDto] = useEditorPreview(freshPreviewDto, freshRequestDto, props.onPreviewUpdate);
    const [onTextChange, onNumberChange, onRteChange, onCheckboxChange, onPopup] = useEditorActions(props.user, "actionType", resources, requestDto, previewDto, setRequestDto, props.onPreviewUpdate);

    // Effects:
    useEffect(() => {
        setRequestDto(freshRequestDto);
    }, [props.actionType]);

    // Styles:
    const widgetClasses = widgets();
    const classes = styles();

    // ActionTypes:
    const reset = () => {
        setRequestDto(freshRequestDto);
        if (props.onPreviewUpdate) {
            props.onPreviewUpdate(props.actionType ?? previewDto);
        }
    };
    
    // Return Component:
    return (
        <div className={`${widgetClasses.form} ${classes.container}`}>
            <div className={`${widgetClasses.row}`}>
                <label>Name</label>
                <input id="name" type="text" value={requestDto.name ?? ""} onChange={onTextChange} />
            </div>

            <hr/>
            <EditorControls
                editorName="actionType"
                service={actionTypeService}
                subject={props.actionType}
                subjectName={props.actionType?.name ?? ""}
                requestDto={requestDto}
                onSave={props.onSave}
                onReset={reset}
                onClose={props.onClose}
            />
            <hr/>
        </div>
    );
}